import { Collapse, Grow, Slide } from '@material-ui/core';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import theme from '../styles/theme';

type ServiceErrorProps = {
  show: boolean;
};

const ServiceError: React.FC<ServiceErrorProps> = ({ show }: ServiceErrorProps) => {
  const [showContent, setShowContent] = useState(true);
  const { t } = useTranslation('error-box');
  const onClick = () => {
    setShowContent(!showContent);
  };
  return (
    <div className="service-error-container">
      <div className="mobile-container">
        <Grow in={show} mountOnEnter unmountOnExit>
          <div className="content">
            <button type="button" onClick={onClick} className="grow-header">
              <h2>{t('title')}</h2>
              <img className="plus-icon" src="/plus.svg" alt="plus-icon"></img>
            </button>
            <Collapse in={showContent} mountOnEnter unmountOnExit>
              <p>{t('text')}</p>
            </Collapse>
          </div>
        </Grow>
      </div>

      <div className="desktop-container">
        <Slide in={show} direction="right" mountOnEnter unmountOnExit>
          <div className="content">
            <h2>{t('title')}</h2>
            <p>{t('text')}</p>
          </div>
        </Slide>
      </div>

      <style jsx>{`
        .service-error-container {
          position: sticky;
          bottom: 56px;
          margin-top: 20px;
          z-index: 1;
        }
        h2 {
          margin: 0;
          text-transform: uppercase;
          font-size: 1rem;
        }
        p {
          font-size: 0.875rem;
        }
        .mobile-container {
          display: block;
        }
        .grow-header {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          background: none;
          border: none;
          width: 100%;
          color: #ffffff;
          padding: 0;
          cursor: pointer;
        }
        .desktop-container {
          display: none;
        }
        .plus-icon {
          margin-left: 10px;
        }
        .content {
          width: 100%;
          padding: 20px;
          padding-top: 15px;
          padding-bottom: 15px;
          background: #707070;
          color: #ffffff;
          border-radius: 4px 4px 0px 0px;
        }
        @media only screen and (min-width: ${theme.breakpoints.values.sm}px) {
          .mobile-container {
            display: none;
          }
          .desktop-container {
            display: block;
          }
          .content {
            max-width: 400px;
            padding-left: 60px;
            padding-top: 30px;
            padding-bottom: 30px;
            padding-right: 50px;
            border-radius: 0;
          }
          .service-error-container {
            position: absolute;
            top: 20;
            left: 0;
            bottom: auto;
          }
        }
      `}</style>
    </div>
  );
};

export default ServiceError;
